'use strict'

import { apiInstance } from './index'

const nfe = {
  sendCityHallInvoice (data) {
    return apiInstance({
      method: 'POST',
      url: '/b2b-cityhall-invoice-app/process',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    })
  },

  getCityHallInvoiceStatus (id) {
    return apiInstance({
      method: 'GET',
      url: `/b2b-cityhall-invoice-app/status/${id}`
    })
  }
}

export default nfe
